import { arrivalReady } from '../../dispatchUi';
import { useNavigate } from 'react-router';
import { surveyorSupplementPath } from '../../utils/surveyorSupplementPath';
import { useContext, useEffect, useRef, useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/joy';
import { LayoutContext } from '../../context';
import { APIAcceptAdditional } from '../../api';
import AdditionalMeasurementPanel from './AdditionalMeasurementPanel';
import { additionalId, hasAdditional } from './additionalActionsUi';

export default function SurveyorAdditionalActions({ event, onChanged, showFinish = true }) {
  const navigate = useNavigate();
  const { account, tokenEmployee, setModalEvent } = useContext(LayoutContext);
  const [updated, setUpdated] = useState(event), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const flight = useRef(false), generation = useRef(0);
  useEffect(() => { generation.current += 1; setUpdated(event); setError(''); }, [event]);
  useEffect(() => () => { generation.current += 1; }, []);
  const item = updated || event, cycle = item?.additional_measurement;
  const employeeId = typeof item?.employee === 'object' ? item.employee?.id : item?.employee;
  const mine = String(employeeId) === String(account?.id);
  if (!hasAdditional(item)) return null;
  const start = async () => {
    if (flight.current) return;
    const run = generation.current;
    flight.current = true; setBusy(true); setError('');
    try {
      const res = await APIAcceptAdditional(item.id, additionalId(item), tokenEmployee);
      if (run !== generation.current) return;
      if (res?.status !== 'ok') setError(res?.message || 'Не удалось принять дозамер');
      else { setUpdated(res.event); onChanged?.(res.event); window.dispatchEvent(new Event('surveyor-additional-changed')); }
    } catch (_) { if (run === generation.current) setError('Ошибка связи. Повторите после обновления карточки.'); }
    finally { flight.current = false; setBusy(false); }
  };
  return <Alert color="danger" variant="soft" onClick={e => e.stopPropagation()} sx={{ my: 1, width: '100%', boxSizing: 'border-box',
    '@keyframes dosePulse': { '0%,100%': { boxShadow: '0 0 0 0 rgba(195,0,19,0.12)' }, '50%': { boxShadow: '0 0 0 5px rgba(195,0,19,0.18)' } },
    animation: cycle?.accepted_at ? 'none' : 'dosePulse 3s ease-in-out infinite',
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' } }}>
    <Stack spacing={1} sx={{ width: '100%' }}>
      <Typography level="title-md" color="danger">{cycle?.accepted_at ? 'Дозамер в работе' : 'Срочно: дополнительный обмер'}</Typography>
      {cycle?.status === 'active' && <AdditionalMeasurementPanel eventId={item.id} cycle={cycle} />}
      {additionalId(item) == null && <Typography level="body-sm">Старое назначение без цикла. Сообщите менеджеру для восстановления задания.</Typography>}
      {error && <Typography color="danger" role="alert">{error}</Typography>}
      {mine && (cycle?.accepted_at
        ? !arrivalReady(item) ? <Button onClick={() => navigate(`/surveyor/arrive/${item.id}`)}>Я на месте · допобмер</Button> : showFinish && <Button color="danger" onClick={() => { setModalEvent({ open: false, event: null }); navigate(surveyorSupplementPath(item)); }}>Завершить дозамер</Button>
        : <Button color="danger" loading={busy} disabled={additionalId(item) == null} onClick={start}>Принять допобмер</Button>)}
    </Stack>
  </Alert>;
}